<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M450.82 427.26l158.73 -195.99 2351.81 0 184.22 195.99 -2694.76 0zm1348.34 2449.8l-1077.9 -1077.9 685.91 0 0 -391.99 783.98 0 0 391.99 685.91 0 -1077.9 1077.9 0 0zm1673.67 -2404.69l-272.37 -329.25c-52.96,-66.67 -133.25,-107.85 -225.4,-107.85l-2351.8 0c-92.15,0 -172.44,41.18 -227.33,107.85l-270.44 329.25c-56.89,66.59 -90.22,150.89 -90.22,248.89l0 2449.8c0.07,216.36 175.63,391.92 392.07,391.92l2743.72 0.07c216.44,-0.07 391.99,-175.63 391.99,-392.07l0 -2449.72c0,-98 -33.33,-182.3 -90.22,-248.89z"/>
  </g>
 </g>
</svg>
